module.exports = __webpack_public_path__ + "static/media/400163_01.4a251419.png";